// extracted by mini-css-extract-plugin
export default {"titlesComponent":"TitleAndSubTitle_titlesComponent__tUHQO","title":"TitleAndSubTitle_title__RAM+J","subTitle":"TitleAndSubTitle_subTitle__DjZ-7"};